
























































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { Gestacao } from '../../../../back/src/entity/Gestacao';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { calculoIdadeGestacional } from '../../utils/functions';
import { Vacinacao } from '../../../../back/src/entity/Vacinacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { tipoPartoStrings } from '../../utils/constants';
import { TipoParto } from '../../../../back/src/types';

export default Vue.extend({
  name: 'VacinacoesDetalhes',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    vacinacao: {
      type: null || Object as () => Vacinacao,
    },
    gestacao: {
      type: null || Object as () => Gestacao,
    },
    paciente: {
      type: null || Object as () => Paciente,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    idadeGestacional(): string {
      if (this.gestacao) {
        return calculoIdadeGestacional(this.gestacao, this.vacinacao.data_vacinacao, true);
      }
      return '';
    },
    tituloGestacao(): string {
      if (!this.gestacao) {
        return 'Sem gestação associada';
      }
      if (this.paciente.gestacao_atual && this.paciente.gestacao_atual.id === this.gestacao.id) {
        const ig = calculoIdadeGestacional(this.gestacao, null, false);
        return `Gestação atual (${ig})`;
      }
      const momentDataParto = moment(this.gestacao.data_parto);
      const dataParto = momentDataParto.isValid() ? momentDataParto.format('DD/MM/YYYY') : '';
      const tipoParto = _.has(tipoPartoStrings, this.gestacao.tipo_parto)
        ? ` - ${tipoPartoStrings[this.gestacao.tipo_parto]}`
        : '';
      let nomeBebes = '';
      if (this.gestacao.tipo_parto === TipoParto.N || this.gestacao.tipo_parto === TipoParto.C) {
        nomeBebes = ` - ${this.gestacao.nome1}${this.gestacao.nome2 ? ` & ${this.gestacao.nome2}` : ''}`;
      }
      return `Gestação anterior (${dataParto}${tipoParto}${nomeBebes})`;
    },
  },
  methods: {
  },
});
